import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("/api/noAuth/plt");

const loginBySmsAsync = (param) => {
    return remoteCall.invoke("loginBySms", param);
};

export default {
    loginBySmsAsync,
};
